import React, { Component } from "react";
import LazyLoad from "react-lazyload";
const IsVaildNumber = /^([0-9][0-9]*)+(.[0-9]{1,})?/g;

class Offer extends Component {
  render() {
    const { data, idx } = this.props;
    if (data.offerimgurl && data.offerimgurl.indexOf("cbu01.alicdn.com") > -1) {
      if (data.offerimgurl.indexOf(".gif") !== -1 && data.offerimgurl.indexOf(".jpg") !== -1) {
        data.offerimgurl = `${data.offerimgurl.replace(/(.summ|.search|.jpg)/g, "")}?_=2020`;
      } else {
        data.offerimgurl = `${data.offerimgurl.replace(
          /summ/g,
          "220x220"
        )}?_=2020`;
      }
    }

    let priceStr = "";
    const match = data.offerprice.match(IsVaildNumber);
    priceStr = match ? match[0] : data.offerprice;
    //
    const isp4p = data.eurl.indexOf("dj.1688.com") != -1 ? 1 : 0;
    const mats = data.clickurl ? data.clickurl.match(/\d+/) : [];
    let offerid;
    if (mats && mats[0]) {
      offerid = mats[0];
    }

    return (
      <div
        className="offer_item guess_offer_item offer_exp"
        data-jplus-exp-url={`${data.impressionEurl}&idx=${idx}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${offerid}^_p_isad@${isp4p}`}
      >
        <div className="img">
          <a href={data.eurl} target="_blank" rel="noreferrer">
            <LazyLoad
              height={200}
              once
              placeholder={<div className="wrap-loading" />}
            >
              <img className="layLoad" src={data.offerimgurl} />
            </LazyLoad>
          </a>
        </div>
        <div className="price_warp price_warp_price_list">
          <a
            href={data.eurl}
            className="mt8 inline_block ml10"
            target="_blank"
            rel="noreferrer"
          >
            <span className="price">
              <i>
                <strong>¥</strong>
              </i>
              {priceStr}
            </span>
          </a>
        </div>
        <div className="c1learfix">
          <a href={data.eurl} target="_blank" rel="noreferrer">
            <div
              className="txt inline_block ml10 mr10 col_555 mt8 new_guess_offer_text"
              dangerouslySetInnerHTML={{ __html: data.title }}
              title={data.title.replace(/<[/]?font.*?>/g, "")}
            />
          </a>
        </div>
      </div>
    );
  }
}
export default Offer;
